<div class="grid m-0 align-items-stretch">
    <div class="col-12">
        <h3 class="m-0 my-3 text-color">Safety Objectives</h3>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Objective Health'"
            [meta]="data.objectiveHealth.meta"
            [chartData]="data.objectiveHealth.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Objectives by Status'"
            [meta]="data.objectivesByStatus.meta"
            [chartData]="data.objectivesByStatus.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'line'"
            [title]="'Objectives Started Over Time'"
            [meta]="data.objectivesOverTime.meta"
            [chartData]="data.objectivesOverTime.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Target Date Outlook'"
            [meta]="data.targetDateOutlook.meta"
            [chartData]="data.targetDateOutlook.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'bars-horizontal'"
            [title]="'Objectives by Owner'"
            [meta]="data.objectivesByOwner.meta"
            [chartData]="data.objectivesByOwner.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12">
        <h3 class="m-0 my-3 text-color">Performance Indicators</h3>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Indicators by Data Source'"
            [meta]="data.indicatorsBySource.meta"
            [chartData]="data.indicatorsBySource.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Indicators by Measurement Interval'"
            [meta]="data.indicatorsByInterval.meta"
            [chartData]="data.indicatorsByInterval.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'bars-horizontal'"
            [title]="'Indicators per Objective'"
            [meta]="data.indicatorsPerObjective.meta"
            [chartData]="data.indicatorsPerObjective.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Targets by Type'"
            [meta]="data.targetsByType.meta"
            [chartData]="data.targetsByType.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12">
        <h3 class="m-0 my-3 text-color">Indicator Trends</h3>
        <p class="m-0 flex align-items-center gap-2 text-sm text-color-secondary">
            <i class="pi pi-info-circle"></i>
            <span>Records are updated nightly. Today's activity will be viewable tomorrow.</span>
        </p>
    </div>

    @for (trend of indicatorTrends; track trend._id) {
        <div class="col-12 lg:col-6">
            @defer (on viewport) {
                <app-card [showHeader]="false" class="h-full w-full" [noMargin]="true">
                    <div card-body class="flex flex-column gap-3">
                        <div class="flex flex-column gap-1 min-w-0">
                            <h3 class="m-0">{{ trend.name }}</h3>
                            <a
                                class="text-sm text-color-secondary no-underline hover:underline"
                                [routerLink]="['/policies/objectives', trend.objectiveId]">
                                {{ trend.objectiveTitle }}
                            </a>
                        </div>
                        <app-spi-chart
                            [dataPoints]="trend.dataPoints"
                            [spts]="trend.spts"
                            [breaches]="trend.breaches"
                            [effectiveDate]="trend.effective_date">
                        </app-spi-chart>
                    </div>
                </app-card>
            } @placeholder {
                <div class="w-full" [style.min-height.px]="indicatorCardPlaceholderHeightPx"></div>
            }
        </div>
    } @empty {
        <div class="col-12">
            <app-empty-state
                variant="inline"
                message="None of the objectives in view have indicators to chart.">
            </app-empty-state>
        </div>
    }

    <div class="col-12">
        <h3 class="m-0 my-3 text-color">Target Breaches</h3>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'line'"
            [title]="'Breaches Over Time'"
            [meta]="data.breachesOverTime.meta"
            [chartData]="data.breachesOverTime.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Breaches by Severity'"
            [meta]="data.breachesBySeverity.meta"
            [chartData]="data.breachesBySeverity.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'doughnut'"
            [title]="'Breaches by Status'"
            [meta]="data.breachesByStatus.meta"
            [chartData]="data.breachesByStatus.chartData">
        </app-stat-chart>
    </div>

    <div class="col-12 lg:col-6">
        <app-stat-chart
            class="w-full"
            [variant]="'bars-horizontal'"
            [title]="'Most Breached Indicators'"
            [meta]="data.mostBreachedIndicators.meta"
            [chartData]="data.mostBreachedIndicators.chartData">
        </app-stat-chart>
    </div>
</div>
